module.exports = __webpack_public_path__ + "img/91.1d1e58d6.svg";